/** Blob URLs for media prepared on this device this session, by storage key, so a person's own
 * new photos show at once, before and while they upload. Lost on reload, when the uploaded copy
 * takes over. */
const previews = new Map<string, string>();
export const localMediaUrl = (key: string) => previews.get(key);
export function keepLocalMedia(key: string, file: Blob) {
  previews.set(key, URL.createObjectURL(file));
}
